<template>
  <template v-if="!isLoadError && loading">
    <request-form mode="Accepted">
      <div>「{{ companyName }}」から企業統合依頼が届きました。</div>
      <div>下記の企業で間違いがなければ、承認ボタンを選択し、企業を統合してください。</div>
      <div>この依頼に心当たりがない場合、拒否ボタンを選択してください。</div>
      <div class="mt-4">企業情報</div>
      <div class="mt-4"></div>
      <ul class="ps-3">
        <li class="terms-item">企業名: {{ companyName }}</li>
        <li class="terms-item">代表アカウント: {{ representativeAccount }}</li>
        <li class="terms-item">郵便番号: {{ postalCode }}</li>
        <li class="terms-item">都道府県: {{ prefectureCode }}</li>
        <li class="terms-item">市区町村: {{ address1 }}</li>
        <li class="terms-item">番地・建物など: {{ address2 }}</li>
        <li class="terms-item">電話番号: {{ tel }}</li>
        <li class="terms-item">FAX番号: {{ fax }}</li>
      </ul>
      <div class="d-flex justify-content-center gap-4">
        <approval-button @click="showAcceptModal" />
        <reject-button @click="showRejectModal" />
      </div>
      <teleport to="body">
        <enterprise-integration-modal ref="acceptModal" message="承認してよろしいですか？">
          <approval-button @click="() => doMergerRequest(true)" />
        </enterprise-integration-modal>
        <enterprise-integration-modal ref="rejectModal" message="拒否してよろしいですか？">
          <reject-button @click="() => doMergerRequest(false)" />
        </enterprise-integration-modal>
      </teleport>
    </request-form>
  </template>
  <template v-else>
    <plain-form>
      <div v-if="isLoadErrorConflict">
        <p>企業統合依頼が無効です。</p>
        <p>既に承認、拒否、または、自動キャンセルされています。</p>
      </div>
      <div v-else-if="isLoadErrorGone">
        <p>URLの有効期限が切れています。</p>
      </div>
      <div v-else-if="isNotFoundResource">
        <p>企業統合依頼が無効です。</p>
        <p>既に承認、拒否、または、自動キャンセルされています。</p>
      </div>
      <div v-else-if="isForbidden">
        <p>ご利用のアカウントでは、操作できません。</p>
      </div>
    </plain-form>
  </template>
  <success-modal ref="successModal" :do-ok="doOk" />
  <message-error-toast ref="serverErrorToast" />
</template>
  
<script>
import { convertPrefectureCodeToName } from '@/constants/prefecture';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import RequestForm from '@/views/templates/forms/RequestForm';
import RejectButton from '@/views/molecules/buttons/RejectButton';
import ApprovalButton from '@/views/molecules/buttons/ApprovalButton';
import EnterpriseIntegrationModal from '@/views/molecules/modals/EnterpriseIntegrationModal';
import SuccessModal from '@/views/molecules/modals/SuccessModal';
import MessageErrorToast from '@/views/molecules/toast/MessageErrorToast';
import { mapState }  from "vuex";
import PlainForm from '@/views/templates/forms/PlainForm';

export default {
  name: "MergerRequestForm",
  components: {
    RequestForm,
    RejectButton,
    ApprovalButton,
    EnterpriseIntegrationModal,
    SuccessModal,
    MessageErrorToast,
    PlainForm
  },
  mixins: [AddonLoadPageEvent],
  computed: {
    ...mapState('merger_request_form',
    {
      representativeAccount: state => state.data.broker_name,
      companyName: state => state.data.name,
      address1: state => state.data.address1,
      address2: state => state.data.address2,
      postalCode: state => state.data.postal_code,
      prefectureCode: state => convertPrefectureCodeToName(state.data.prefecture_code),
      tel: state => state.data.tel,
      fax: state => state.data.fax,
      isLoadErrorConflict: state => state.isLoadErrorConflict,
      isLoadErrorGone: state => state.isLoadErrorGone,
      isNotFoundResource: state => state.isNotFoundResource,
      isForbidden: state => state.isForbidden,
    }),
    isLoadError() {
      return this.isLoadErrorConflict || this.isLoadErrorGone || this.isNotFoundResource || this.isForbidden;
    },
  },
  data(){
    return {
      loading: false
    }
  },
  mounted() {
    this.$store.dispatch('startPageLoading').then(() => {
      this.$store.dispatch('merger_request_form/load',
      {
        id: this.$route.params?.id
      })
      .then(() => this.loading = true)
      .catch(() => this.loading = true);
    }).catch(reason => this.$root.failApi(reason)).finally(() => this.$store.dispatch('stopPageLoading'));
  },
  methods: {
    showAcceptModal() {
      this.$refs.acceptModal.show();
    },
    showRejectModal() {
      this.$refs.rejectModal.show();
    },
    doMergerRequest(status) {
      if (status) {
        this.$refs.acceptModal.hide();
      }
      if (!status) {
        this.$refs.rejectModal.hide();
      }
      const body = {
        id: this.$route.params?.id,
        status: status
      }
      this.$store.dispatch('merger_request_form/approval', body)
      .then((res) => {
        if (res) {
          this.$refs.successModal.show(status ? '企業統合依頼を承認しました。' : '企業統合依頼を拒否しました。');
        }
      })
      .catch(reason => this.$root.failApi(reason));
    },
    doOk(){
      this.$router.push({ name: 'BrokerageCompanyViewer' });
      this.$refs.successModal.hide();
    }
  }
}
</script>

<style scoped>
  .terms-item {
    list-style: none;
  }
</style>